import { render, staticRenderFns } from "./epqForm.vue?vue&type=template&id=9818e030&scoped=true"
import script from "./epqForm.vue?vue&type=script&lang=js"
export * from "./epqForm.vue?vue&type=script&lang=js"
import style0 from "./epqForm.vue?vue&type=style&index=0&id=9818e030&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9818e030",
  null
  
)

export default component.exports